<template>
  <section v-if="active" class="app-modal__section">
    <header class="app-modal__section-head contributor-fiscal-address__head">
      <div class="contributor-fiscal-address__head-copy">
        <h4>{{ text.modal.form.fiscalAddress.title }}</h4>
        <p>{{ text.modal.form.fiscalAddress.subtitle }}</p>
      </div>

      <label class="app-modal-toggle app-modal-toggle--primary contributor-fiscal-address__skip-toggle">
        <input v-model="form.skipFiscalAddress" type="checkbox" />
        <span>{{ text.modal.form.fiscalAddress.fields.skipFiscalAddress }}</span>
      </label>
    </header>

    <div v-if="!form.skipFiscalAddress" class="app-modal__grid two-columns mt-3">
      <div class="app-modal-field">
        <span>{{ text.modal.form.fiscalAddress.fields.state }}</span>
        <multiselect
          v-model="form.state"
          :options="stateOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="128"
          open-direction="below"
          :placeholder="text.modal.form.fiscalAddress.placeholders.state"
          class="app-modal-select"
        />
      </div>

      <label class="app-modal-field">
        <span>{{ text.modal.form.fiscalAddress.fields.municipality }}</span>
        <input
          v-model.trim="form.municipality"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.fiscalAddress.placeholders.municipality || 'Captura municipio'"
        />
      </label>

      <label class="app-modal-field full-width">
        <span>{{ text.modal.form.fiscalAddress.fields.street }}</span>
        <input
          v-model.trim="form.street"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.fiscalAddress.placeholders.street || 'Captura calle'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.fiscalAddress.fields.exterior }}</span>
        <input
          v-model.trim="form.exterior"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.fiscalAddress.placeholders.exterior || 'No. exterior'"
        />
      </label>

      <label class="app-modal-field">
        <span>{{ text.modal.form.fiscalAddress.fields.interior }}</span>
        <input
          v-model.trim="form.interior"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.fiscalAddress.placeholders.interior || 'No. interior (opcional)'"
        />
      </label>

      <label class="app-modal-field full-width">
        <span>{{ text.modal.form.fiscalAddress.fields.neighborhood }}</span>
        <input
          v-model.trim="form.neighborhood"
          type="text"
          class="form-control"
          autocomplete="off"
          :placeholder="text.modal.form.fiscalAddress.placeholders.neighborhood || 'Captura colonia'"
        />
      </label>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('billingData');

export default {
  name: 'ContributorSectionFiscalAddress',
  data() {
    return {
      text,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    v$: {
      type: Object,
      default: null,
    },
    stateOptions: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.contributor-fiscal-address__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.contributor-fiscal-address__head-copy {
  min-width: 0;
}

.contributor-fiscal-address__skip-toggle {
  margin: 0;
  max-width: 360px;
}

.contributor-fiscal-address__skip-toggle input {
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  flex: 0 0 18px;
}

@media (max-width: 900px) {
  .contributor-fiscal-address__head {
    flex-direction: column;
  }

  .contributor-fiscal-address__skip-toggle {
    max-width: none;
  }
}
</style>
